import React from 'react'
import { useTranslation } from 'react-i18next'

const AboutProduct = () => {
  const { t } = useTranslation()

  return (
    <section className="about">
      <div className="container">
        <h2>{t('about.title')}</h2>
        <p>{t('about.description')}</p>
        <div className="features">
          <div className="feature">🌿 {t('about.feature1')}</div>
          <div className="feature">⚡ {t('about.feature2')}</div>
          <div className="feature">🛡️ {t('about.feature3')}</div>
        </div>
      </div>
    </section>
  )
}

export default AboutProduct
